import { memo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DocViewer, { IDocument } from '@cyntler/react-doc-viewer';
import PDFRenderer from '@cyntler/react-doc-viewer/dist/cjs/renderers/pdf';
import Button from '@mui/material/Button';
import { JPGRenderer, PNGRenderer } from './renderers';
import { HeaderBar } from './HeaderBar';
import { OrderFile } from '../../Models';

function MyNoRenderer({ document }: { document: IDocument | undefined }) {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                px: 10,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
            <Button
                sx={{ mb: 5 }}
                variant="contained"
                component="a"
                href={document?.uri}
                target="_blank"
                rel="noopener noreferrer">
                Abrir página
            </Button>
            <a
                href={document?.uri}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}>
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ mt: 1, display: 'block', textAlign: 'center', wordBreak: 'break-all' }}>
                    {document?.uri}
                </Typography>
            </a>
        </Box>
    );
}
type FileViewerProps = {
    files: OrderFile[];
};
function DocViewerComponent({ files }: FileViewerProps) {
    return (
        <DocViewer
            style={{ height: '95%', margin: 0, padding: 0 }}
            documents={files.map((f, i) => ({
                uri: f.storage_url || f.original_url,
                fileType: f.mime_type,
                fileName: `${i}`,
            }))}
            language="es"
            pluginRenderers={[PNGRenderer, JPGRenderer, PDFRenderer]}
            config={{
                header: {
                    overrideComponent: HeaderBar,
                },
                pdfZoom: {
                    defaultZoom: 2.1,
                    zoomJump: 0.7,
                },
                pdfVerticalScrollByDefault: false,
                noRenderer: {
                    overrideComponent: MyNoRenderer,
                },
            }}
        />
    );
}

const FileViewer = memo(
    DocViewerComponent,
    (prevProps, nextProps) => prevProps.files.sort().join(',') === nextProps.files.sort().join(','),
);

export default FileViewer;
